import { useMemo } from "react"
import { useQuery } from "urql"

import { PRICE_CHANGE_PAGE_SIZE } from "../constants"

import {
  GetPriceChangeItemsDocument,
  type GetPriceChangeItemsInput,
  type GetPriceChangeItemsQuery,
  type PriceChangeItems,
} from "@/graphql/codegen/graphql"

import "../graphql/queries"

interface UseGetPriceChangeItemsReturn {
  priceChangeItems: PriceChangeItems[]
  total: number
  isFetching: boolean
  pageCount: number
}

export const useGetPriceChangeItems = (
  input: GetPriceChangeItemsInput | null,
  page: number
): UseGetPriceChangeItemsReturn => {
  const [{ data, fetching }] = useQuery<GetPriceChangeItemsQuery>({
    query: GetPriceChangeItemsDocument,
    variables: { input: { ...input!, offset: (page - 1) * PRICE_CHANGE_PAGE_SIZE, limit: PRICE_CHANGE_PAGE_SIZE } },
    pause: !input,
  })

  const { items: fetched, total: fetchedTotal } = useMemo(() => {
    if (data?.priceChange.getPriceChangeItems.__typename === "GetPriceChangeItemsSuccess") {
      const success = data.priceChange.getPriceChangeItems
      return {
        items: success.priceChangeItems as PriceChangeItems[],
        total: success.pageInfo.total,
      }
    }
    return { items: [] as PriceChangeItems[], total: 0 }
  }, [data])

  return {
    priceChangeItems: fetched,
    total: fetchedTotal,
    isFetching: fetching,
    pageCount: Math.ceil(fetchedTotal / PRICE_CHANGE_PAGE_SIZE),
  }
}
